import React, { useState } from 'react';
import { observer } from 'src/utils/mobx-react';
import { useAppStateContext } from 'src/AppState/AppState';
import { CasinoContainer } from 'src/domains/casino/components/CasinoContainer';
import { CasinoGameEditPage } from 'src/domains/casino/pages/CasinoGameEditPage';
import { MainContent } from 'src/domains/layouts/shared/layout/Layout.style';
import { LiveGamesState } from 'src/domains/casino/state/AppCasino/live-games/LiveGames.state';
import { CollectionType } from 'src/domains/casino/models/models';
import { useCommon } from 'src/AppState/Common';

interface CasinoPageType {
    collection: CollectionType;
}

export const CasinoPage = observer('CasinoPage', (props: CasinoPageType): React.ReactElement | null => {
    const { appCasinoState } = useAppStateContext();
    const { casinoViewParam } = appCasinoState.redirectState;
    const common = useCommon();
    const [liveGamesState] = useState(() => new LiveGamesState(appCasinoState.gameStore, props.collection, common));
    const collectionData = appCasinoState.gameStore.getCollection(props.collection);

    if (casinoViewParam === null) {
        return null;
    }

    return (
        <MainContent>
            {casinoViewParam === 'games' && <CasinoContainer liveGamesState={liveGamesState} />}
            {casinoViewParam === 'edit-live-game' && <CasinoGameEditPage collectionData={collectionData} />}
        </MainContent>
    );
});
